import { getMe } from "@/apis/oneclub/services/members";
import type { UserProfileSource } from "../types";

export const oneClubUserProfileSource: UserProfileSource = {
  key: "oneclub",
  fetchProfile: async (token) => {
    const { name } = await getMe({ jwt: token });

    return { fullName: name };
  },
};
